const React = require('react');
const {firebase, getAuth,getCurrentEnablePersistence,setCurrentEnablePersistence,updateProfile} = require("./firebase.jsx");
const {ChangePassword} = require('./authenticate.jsx');
const {campaign,globalDataListener,areSameDeep, addCampaignToPath, adventurerProductId,gamemasterProductId,gamemasterProProductId} = require('../lib/campaign.js');
const {displayMessage} = require('./notification.jsx');
const {Dialog,DialogTitle,DialogActions,DialogContent} = require('./responsivedialog.jsx');
const {ListFilter} = require('./listfilter.jsx');
const {HoverMenu} = require( "./hovermenu.jsx");
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import Slider from '@material-ui/core/Slider';
const {TextBasicEdit, DeleteWithConfirm, CheckVal, SelectVal} = require('./stdedit.jsx');
const {Renderplayers,NewCharacter, matchExtensions, getMatchingCampaigns} = require("./renderplayers.jsx");
const {NewBook,LibraryList} = require('./book.jsx');
const {GlobalEnablePackageDialog,PackageDialog,AdminPackageDialog} = require('./packages.jsx');
const {UnlockKeys,ConfigurePublisherInfo,SendGifts,SendKeys,CouponsDialog,SendPublisherEmail,AssignStuff} = require('./products.jsx');
const {PurchaseSubscriptions, SalesResults,Accounting,DistributeCredits} = require('./purchase.jsx');
const {BannerStart,StartAdsDialog} = require('./banner.jsx');
const {RulesetHeader,NewCampaign} = require('./campaignconfig.jsx');
const {extensionsFromSaved} = require('../lib/character.js');
const {ArtPicker} = require('./renderart.jsx');
const {fTemplateName} = require('../lib/monobj.js');
const {PickFont} = require('./theme.jsx');

class HomePage extends React.Component {
    constructor(props) {
        super(props);
	    this.state= {};
    }

    render() {
        let showBackground = !(campaign.getMyCharacters().length);

        if (showBackground && (campaign.getPrefs().playerMode != "ruleset")) {
            const campaigns = campaign.getCampaignsList();
            for (let i in campaigns) {
                const cInfo = campaigns[i];
                if ((cInfo.name != "emptycampaign") && (cInfo.playerMode != "ruleset")) {
                    showBackground =false;
                }
            }
        }
    
        return <div className="h-100 w-100 overflow-y-auto overflow-x-hidden">
            <RulesetHeader/>
            <NotificationBlock/>
            <div className="flex flex-wrap justify-center pa1">
                <HomePageBlock id="tourCharacters" title="My Characters" titleClick={navTo.bind(null, addCampaignToPath("/#mycharacters"),null)}>
                    <CharactersBlock showBackground={showBackground} pageSync={this.props.pageSync}/>
                </HomePageBlock>
                <HomePageBlock id="tourCampaign" title="Campaigns" titleClick={navTo.bind(null, addCampaignToPath("/#campaigns"),null)}>
                    <CampaignsBlock showBackground={showBackground} pageSync={this.props.pageSync}/>
                </HomePageBlock>
            </div>
            <BannerStart/>
            <div className="flex flex-wrap justify-center pa1">
                <HomePageBlock id="tourLibrary" title="Library" titleClick={navTo.bind(null, addCampaignToPath("/#book"),null)}>
                    <BooksBlock pageSync={this.props.pageSync}/>
                </HomePageBlock>
                <HomePageBlock id="tourReference" title="Reference"  titleClick={navTo.bind(null, addCampaignToPath("/#reference"),null)}>
                    <GamePlayReferenceBlock pageSync={this.props.pageSync}/>
                </HomePageBlock>
            </div>
            <TOS  color="titlecolor"/>
        </div>
    }
}

function isRuleset() {
    const campaigns = campaign.getCampaignsList();
    for (let i in campaigns) {
        const cInfo = campaigns[i];
        if (cInfo.playerMode == "ruleset") {
            return true;
        }
    }
    return false;
}

class HomePageBlock extends React.Component {
    render() {
        return <Paper id={this.props.id} className="b--transparent w-40 minw55 br3 mw7 flex-auto ma1 overflow-hidden flex flex-column stdcontent bg-transparent" elevation={4} square>
            {this.props.title?<div className="tc f2 pa1 titlesolidbackground titletext titlecolorcontrast">
                {this.props.titleClick?<a onClick={this.props.titleClick}>{this.props.title}</a>:this.props.title}
            </div>:null}
            <div className="f4 titlecolor pa1 flex-auto flex flex-column homepageblock">
                {this.props.children}
            </div>
        </Paper>
    }
}

class CharactersBlock extends React.Component {
    constructor(props) {
        super(props);
	    this.state= {};
    }

    render() {
        return <div className="flex-auto flex flex-column  minh3">
            <div className={"flex-auto"+(this.props.showBackground?" characterbackground":"")}>
                <Renderplayers doNav type="mycharacters" limit pageSync={this.props.pageSync} emptyInfo=" "/>
            </div>
            <div className="tr mt1">
                <Button className="ml2 mr1 minw2" color="primary" variant="outlined" onClick={this.clickNew.bind(this)} size="small">New Character</Button>
            </div>
            <NewCharacter open={this.state.showNewPC} onClose={this.onNewPC.bind(this)} type="mycharacters"/>
        </div>;
    }

    clickNew() {
        if (campaign.getMyCharacters().length >= campaign.maxCharacters) {
            displayMessage(<span>You have reached your limit of {campaign.maxCharacters} characters that you can create.  See <a href="/marketplace#shardsubscriptions">subscriptions</a> to change your limits.</span>);
            return;
        }
        this.setState({showNewPC:true})
    }

    onNewPC(name) {
        if (name) {
            window.location.href = addCampaignToPath("/#mycharacters?id="+encodeURIComponent(name),true);
        }
        this.setState({showNewPC:false});
    }
}

class BooksBlock extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnDataChange = this.onDataChange.bind(this);
	    this.state= {books:campaign.getBookList()};
        this.onClickNewBookFn = this.onClickNewBook.bind(this);
    }

    componentDidMount() {
        this.props.pageSync.addListener("newBook",this.onClickNewBookFn);
        globalDataListener.onChangeCampaignContent(this.handleOnDataChange, "books");
    }

    componentWillUnmount() {
        this.props.pageSync.removeListener("newBook",this.onClickNewBookFn);
        globalDataListener.removeCampaignContentListener(this.handleOnDataChange, "books");
    }

    onDataChange() {
        this.setState({books:campaign.getBookList()});
    }


    render() {
        return <div className="flex-auto flex flex-column titleanchor">
            <LibraryList/>
            <div className="flex-auto"/>
            <div className="tr">
                <Button className="ml2 minw2" color="primary" variant="outlined" onClick={this.onClickNewBook.bind(this)} size="small">New Book</Button>
            </div>
            <NewBook open={this.state.showNewBook} onClose={this.closeNewBook.bind(this)}/>
        </div>;
    }

    closeNewBook(name){
        if (name) {
            navTo(addCampaignToPath("/#book?mode=edit",true)+"&id=", name);
        }
        this.setState({showNewBook:false});
    }

    onClickNewBook(){
        this.setState({showNewBook:true});
    }
}

class CampaignsBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state= {};
    }

    render() {
        return <div className="flex-auto flex flex-column minh3">
            <div className={"flex-auto"+(this.props.showBackground?" campaignbackground":"")}>
                <CampaignsList pageSync={this.props.pageSync}/>
            </div>
            <div className="tr">
                <Button className="ml2 minw2" color="primary" variant="outlined" onClick={this.showNew.bind(this,true,false)} size="small">New Campaign</Button>  
            </div>
            <NewCampaign open={this.state.showNew} onClose={this.showNew.bind(this, false,false)}/>
        </div>;
    }

    showNew(showNew, ruleset) {
        this.setState({showNew, ruleset})
    }
}

class CampaignsHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state= {};
    }

    render() {
        return <span>
            Campaigns
            <Button className="ml2 minw2" color="primary" variant="outlined" onClick={this.showNew.bind(this,true,false)} size="small">New Campaign</Button>  
            {campaign.allowTemplates?<Button className="ml2 minw2" color="primary" variant="outlined" onClick={this.showNew.bind(this,true,true)} size="small">New Ruleset</Button>:null}
            <NewCampaign open={this.state.showNew} ruleset={this.state.ruleset} onClose={this.showNew.bind(this, false,false)}/>
        </span>;
    }

    showNew(showNew, ruleset) {
        this.setState({showNew, ruleset})
    }
}


class CampaignsListCardTest extends React.Component {
    constructor(props) {
        super(props);
        this.state= {};
        this.handleOnDataChange = this.onDataChange.bind(this);
    }

    componentDidMount() {
        globalDataListener.onChangeUserSettings(this.handleOnDataChange);
    }

    componentWillUnmount() {
        globalDataListener.removeUserSettingsListener(this.handleOnDataChange);
    }

    onDataChange() {
        this.setState({list:campaign.getCampaignsList()});
    }


    render() {
        const campaigns = campaign.getCampaignsList();
        const list = [];
        const shareCampaigns = campaign.getShareCampaigns();
        const isRuleset = (campaign.getPrefs().playerMode == "ruleset");
        const extensions = isRuleset?extensionsFromSaved(campaign.getGameState()?.extensions):null;
        const matchingCampaigns = getMatchingCampaigns(extensions);



        for (let i in campaigns) {
            const cInfo = Object.assign({}, campaigns[i]);

            if (!cInfo.playerMode && !cInfo.shareCampaign) {
                if (matchingCampaigns[cInfo.name]) {
                    cInfo.group ="Gamemaster";
                    list.push(cInfo);
                }
            } else if (cInfo.shareCampaign) {
                if (matchingCampaigns[cInfo.name]) {
                    cInfo.group ="Player";
                    cInfo.playerSharing = shareCampaigns.includes(cInfo.shareCampaignName);
                    list.push(cInfo);
                }
            }
        }
        console.log("list", list);
        list.sort(function (a,b) {const group = a.group.localeCompare(b.group); if (group !=0) return group; return (a.displayName||"").toLowerCase().localeCompare((b.displayName||"").toLowerCase()) });

        return <div className="notecontent">
            <ListFilter 
                list={list}
                render={this.campaignRender.bind(this)}
                filters={null}
                onClick={this.onSelectCampaign.bind(this)}
                groupBy="group"
                smallCard
                headerOutline
                hideSearch
            />
            <Dialog open={this.state.deleting||false}>
                <DialogContent>
                    Deleting...
                </DialogContent>
            </Dialog>
        </div>;
    }

    campaignRender(cInfo) {
        return <div>
            <div className="fr f8"><DeleteWithConfirm className="pa1" name={cInfo.displayName} onClick={this.deleteCampaign.bind(this, cInfo.name)}/></div>
            {cInfo.playerSharing?<span className="pv1 pr1 fas fa-book-reader"/>:null}{cInfo.displayName}
        </div>;
    }

    campaignRenderCard(cInfo, width,bc,sel,clickCampaign) {
        return <div key={cInfo.name} className="defaultbackground shadow-3 br3 ma--2 overflow-hidden" style={{width:width-4}}>
            <div className="cursor-context-menu pa--3 flex hoverhighlight">
                <img height="70" width="70" src={"/blankplayer.png"} onClick={clickCampaign}/>
                <div className="flex-auto ph1">
                    <div className="f4 titletext titlecolor">
                        <div className="fr f8"><DeleteWithConfirm className="pa1" name={cInfo.displayName} onClick={this.deleteCampaign.bind(this, cInfo.name)}/></div>
                        <div onClick={clickCampaign}>{cInfo.displayName}</div>
                    </div>
                    <div className="f6 lightcolor i" onClick={clickCampaign}>
                        <div>{cInfo.playerSharing?<span className="pv1 pr1 fas fa-book-reader"/>:null}{cInfo.group}</div>
                    </div>
                </div>
            </div>
        </div>;
    }

    onSelectCampaign(name) {
        const cInfo = campaign.getCampaignInfo(name);
        console.log("select campaign", name, cInfo);
        
        if (!cInfo.playerMode && !cInfo.shareCampaign) {
            navTo("#adventure?cid=", cInfo.name);
        } else if (cInfo.shareCampaign) {
            navTo("#play?mode=map&campaign=", cInfo.name);
        }
    }

    deleteCampaign(name) {
        const t=this;
        campaign.deleteCampaign(name).then(function (){
            t.setState({deleting:false});
        }, function (err) {
            t.setState({deleting:false});
            displayMessage("Error deleting campaign "+name+": "+err.message);
        })
        this.setState({deleting:true});
    }
}

class CampaignsList extends React.Component {
    constructor(props) {
        super(props);
        this.state= {};
        this.handleOnDataChange = this.onDataChange.bind(this);
    }

    componentDidMount() {
        globalDataListener.onChangeUserSettings(this.handleOnDataChange);
    }

    componentWillUnmount() {
        globalDataListener.removeUserSettingsListener(this.handleOnDataChange);
    }

    onDataChange() {
        this.setState({list:campaign.getCampaignsList()});
    }


    render() {
        const campaigns = campaign.getCampaignsList();
        const players = [];
        const dms = [];
        const rulesets=[];
        const shareCampaigns = campaign.getShareCampaigns();
        const allowTemplates = campaign.allowTemplates;
        const isRuleset = (campaign.getPrefs().playerMode == "ruleset");
        const extensions = isRuleset?extensionsFromSaved(campaign.getGameState()?.extensions):null;
        const matchingCampaigns = getMatchingCampaigns(extensions);

        for (let i in campaigns) {
            const cInfo = campaigns[i];

            if (cInfo.playerMode == "ruleset") {
                if (false && matchingCampaigns[cInfo.name]) {
                    rulesets.push(<div key={i} className="flex hoverhighlight ml1">
                        <div className="pt--3 pb--2 flex-auto" onClick={navTo.bind(null, "#home?cid=", cInfo.name)}>
                            <span className="pa1 fas fa-atlas"/>{cInfo.displayName}
                        </div>
                        {(allowTemplates||!(campaign.getExtensionInfo(cInfo.name)?.template))?<DeleteWithConfirm className="pa1" name={cInfo.displayName} onClick={this.deleteCampaign.bind(this, cInfo.name)} confirm={cInfo.displayName} extraDescription="This will remove all of the information about the campaign and cannot be recovered."/>:null}
                    </div>);
                }
            } else if (!cInfo.playerMode && !cInfo.shareCampaign) {
                if (matchingCampaigns[cInfo.name]) {
                    dms.push(<div key={i} className="flex hoverhighlight ml1">
                        <div className="pt--3 pb--2 flex-auto" onClick={navTo.bind(null, "#adventure?cid=", cInfo.name)}>
                            <span className="pa1 fas fa-dungeon"/>{cInfo.displayName}
                        </div>
                        <DeleteWithConfirm className="pa1" name={cInfo.displayName} onClick={this.deleteCampaign.bind(this, cInfo.name)} confirm={cInfo.displayName} extraDescription="This will remove all of the information about the campaign and cannot be recovered."/>
                    </div>);
                }
            } else if (cInfo.shareCampaign) {
                if (matchingCampaigns[cInfo.name]) {
                    players.push(<div key={i} className="flex hoverhighlight ml1">
                        <div className="pt--3 pb--2 flex-auto" onClick={navTo.bind(null, "#play?mode=map&campaign=", cInfo.name)}>
                            <span className="pa1 fas fa-walking"/>
                            {shareCampaigns.includes(cInfo.shareCampaignName)?<span className="pv1 pr1 fas fa-book-reader"/>:null}
                            {cInfo.displayName}
                        </div>
                        <DeleteWithConfirm className="pa1" name={cInfo.displayName} onClick={this.deleteCampaign.bind(this, cInfo.name)}/>
                    </div>);
                }
            }
        }

        return <div className="stdcontent">
            <div className="titlecolor f4">
                {dms.length?<div>
                    <div className="b bb titleborder">Gamemaster</div>
                    {dms}
                </div>:null}
                {players.length?<div>
                    <div className="b mt1 bb titleborder">Player</div>
                    {players}
                </div>:null}
                {rulesets.length?<div>
                    <div className="b mt1 bb titleborder">Rulesets</div>
                    {rulesets}
                </div>:null}
            </div>
            <Dialog open={this.state.deleting||false}>
                <DialogContent>
                    Deleting...
                </DialogContent>
            </Dialog>
        </div>;
    }

    deleteCampaign(name) {
        const t=this;
        campaign.deleteCampaign(name).then(function (){
            t.setState({deleting:false});
        }, function (err) {
            t.setState({deleting:false});
            displayMessage("Error deleting campaign "+name+": "+err.message);
        })
        this.setState({deleting:true});
    }
}

class GamePlayReferenceBlock extends React.Component {
    render() {
        return <div className="flex-auto flex flex-column">
            <GamePlayReferenceList/>
            <div className="flex-auto"/>
            <div className="tr">
                <Button className="ml2 minw2" color="primary" variant="outlined"  onClick={navTo.bind(null, addCampaignToPath("#mycreations"),null)} size="small">My Creations</Button>
            </div>
        </div>;
    }
}

const skipBFGamesystem = ["Lineages", "Heritages"];
class GamePlayReferenceList extends React.Component {
    constructor(props) {
        super(props);

        this.state= {};
    }

    render() {
        const {expanded,advanced}=this.state;
        const list = [];
        const cl = campaign.getCustomTablesList();
        let showBF = campaign.hasBFGamesystem;

        for (let i in cl) {
            const it = cl[i];
            if (skipBFGamesystem.includes(it)) {
                showBF=true;
            } else if ((it!="Conditions")&&expanded&&campaign.getSortedCustomList(it).length) {
                list.push(<div className="mb1 w-50 flex-auto minw4" key={it}><a href={addCampaignToPath("/#customtable?type="+encodeURIComponent(it),true)}>{it}</a></div>);
            }
        }

        return <div className="stdcontent pa1">
            <div className="flex flex-wrap titleanchor titlecolor f4">
                <div className="w-100 b mt1 bb titleborder">Character Options</div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#backgrounds")}>Backgrounds</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#class")}>Classes</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#feats")}>Feats</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#item")}>Items</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#race")}>{campaign.racesText}</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#spell")}>Spells</a></div>
                {showBF?<div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#customtable?type=Lineages",true)}>Lineages</a></div>:null}
                {showBF?<div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#customtable?type=Heritages",true)}>Heritages</a></div>:null}
                <div className="w-100 b mt1 bb titleborder">Gamemaster Options</div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#art")}>Artwork</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#audio")}>Audio Clips</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#customtable?type=Conditions",true)}>Conditions</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#maps")}>Maps</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#monster")}>Monsters</a></div>
                <div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#pregen")}>Pregenerated Characters</a></div>
                <div className="w-100 b mt1 bb titleborder hoverhighlight" onClick={this.setExpanded.bind(this,!expanded)}>Custom Types <span className={expanded?"fr fas fa-caret-up":"fr fas fa-caret-down"}></span></div>
                {list}
                <div className="w-100 b mt1 bb titleborder hoverhighlight" onClick={this.setAdvancedExpanded.bind(this,!advanced)}>Advanced <span className={advanced?"fr fas fa-caret-up":"fr fas fa-caret-down"}></span></div>
                {advanced?<div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath(`/#customtable?type=${fTemplateName}`,true)}>{fTemplateName}</a></div>:null}
                {advanced?<div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#extensions")}>Extensions</a></div>:null}
                {advanced?<div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#pins")}>Pins</a></div>:null}
                {advanced?<div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#plannedencounters")}>Planned Encounters</a></div>:null}
                {advanced?<div className="mb1 w-50 flex-auto minw4"><a href={addCampaignToPath("/#randomtables")}>Random Encounters</a></div>:null}
            </div>
        </div>;
    }

    setExpanded(expanded) {
        this.setState({expanded});
    }

    setAdvancedExpanded(advanced) {
        this.setState({advanced});
    }

}

class AccountSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state= {};
    }

    render() {
        const user =campaign.currentUser;
        const userSettings = campaign.getUserSettings();
        const activeTime = (userSettings.activeTime||0)/60;
        const list=[];
        const publisher = campaign.publisher;
        const claimableCredits = campaign.claimableCredits;
        const apiunlock = campaign.apiunlock;
        const playSounds=campaign.playSounds,
        diceVolume=this.state.diceVolume||campaign.diceVolume,
        showDebugDice=campaign.showDebugDice;
        const art = campaign.getArtInfo(userSettings.wallpaper);

        const cl = campaign.getCampaignsList().concat([]);
        cl.sort(function (a, b) { return (b.activeTime||0)-(a.activeTime||0)});
        for (let i in cl) {
            const c = cl[i];
            if ((c.displayName != "emptycampaign")&&(c.activeTime >= 30)) {
                list.push(<tr key={c.name} className="f3"><td className="tr"><span className="numbers">{(c.activeTime/60).toFixed(1)}</span></td><td>{c.displayName} {c.playerMode?"(player)":null}</td></tr>);
            }
        }

        return <div className="titletext f2 pa2 titlecolor">
            <div className="f1">
                {user.displayName} <Button color="primary" variant="outlined" onClick={this.changeName.bind(this)} size="small">Change Name</Button>&nbsp;
                {campaign.isPasswordLogon?<Button color="primary" variant="outlined" onClick={this.showChangePassword.bind(this, true)} size="small">Change Password</Button>:null}
            </div>
            <div className="mb2 f3">
                {user.email} {!user.emailVerified?<span className="light-red">(email address not verified)  <a onClick={this.resendCode.bind(this)}>Resend verification email</a></span>:null}
                <div>{this.state.message}</div>
            </div>
            {(activeTime>0.1)?<div className="mb2 f3 stdcontent">
                <div className="f3 notetext">{activeTime.toFixed(1)} Total hours using Shard Tabletop</div>
                {list.length?<table>
                    <tbody>
                        <tr className="f3"><td>Hours</td><td className="w-100">Campaign</td></tr>
                        {list}
                    </tbody>
                </table>:null}
            </div>:null}
            <div className="stdcontent">
                <h2>Appearance & Sound</h2>
                <div>
                    <CheckVal label="Dark mode (Show application with light text on a dark background)" value={userSettings.darkMode||false} onChange={this.toggleDarkMode.bind(this)}/>
                </div>

                <div className="mv1">
                    <PickFont overrideDefault font={userSettings.font} onClick={this.setUserSettings.bind(this,"font")}/>
                </div>

                <div className="mv1">
                    <b>Wallpaper Image:</b> {art?.displayName}
                    <Button className="mh2" onClick={this.onPickWallpaper.bind(this)} color="primary" size="small" variant="outlined">Pick</Button>
                    <Button onClick={this.setUserSettings.bind(this,"wallpaper", null)} color="primary" size="small" variant="outlined">Clear</Button>
                </div>

                {false?<div>
                    <CheckVal label="Enable storage persistence (device specific)" value={getCurrentEnablePersistence()} onChange={this.togglePersistance.bind(this)}/>
                    <div>Persistence enables limited offline support and improved performance</div>
                </div>:null}
                {campaign.isDebugVersion?<div>
                    <CheckVal label="Show debug dice" value={showDebugDice} onChange={this.setUserSettings.bind(this,"showDebugDice", !showDebugDice)}/>
                </div>:null}
                <div className="flex items-center">
                    <div>
                        Sound
                        <span className={playSounds?"fas fa-volume-up f3 hoverhighlight pa1 mh1":"fas fa-volume-mute f3 hoverhighlight pa1"} onClick={this.setUserSettings.bind(this,"playSounds", !playSounds)}/>
                    </div>
                    <Slider className="mw5 mh3" disabled={!playSounds} value={diceVolume||1} min={1} onChange={this.onChangeVolume.bind(this)} onChangeCommitted={this.onCommitChangeVolume.bind(this)}/>
                </div>

                <PurchaseSubscriptions/>
                <h2>Packages</h2>
                <p>
                    <a onClick={this.clickDisablePackages.bind(this)}>Select Enabled Packages</a>: Pick enabled packages and which ones should be hidden. 
                </p>
                <p>
                    <a href="/#mypackages">My Packages</a>: View and create packages for sharing or selling in the marketplace.
                </p>
                
                {claimableCredits?<p>
                    <a onClick={this.showDistribute.bind(this,true)}>Payout Credits</a>: Payout credits via Paypal.
                </p>:null}
                {publisher?<div>
                    <h2>Products</h2>
                    <p>
                        <a href="/#products">Manage Products</a>: View and create products to sell in the marketplace.
                    </p>
                    <p>
                        <a onClick={this.showSalesResults.bind(this,true)}>Sales Report</a>: View sales totals for your products.
                    </p>
                    <p>
                        <a onClick={this.showCoupons.bind(this,true)}>Discount Coupons</a>: View and create discount codes for your products.
                    </p>
                    {apiunlock?<p>
                        <a onClick={this.showUnlockKeys.bind(this,true)}>API Key Unlock Secrets</a>: View and rotate secrets for making API calls to create product unlock keys.
                    </p>:null}
                    <p>
                        <a onClick={this.showPublisherInfo.bind(this, true)}>Publisher Information:</a> Set publisher information to be displayed on publisher page in marketplace.
                    </p>
                    {campaign.publisherSender?<p>
                        <a onClick={this.setState.bind(this,{showPublisherEmail:true},null, null)}>Send Email:</a> Send email to all customers that have purchased one of your products.
                    </p>:null}
                </div>:<p>Contact us at <a href="mailto:shard@shardtabletop.com">shard@shardtabletop.com</a> if you would like to learn about publishing products to the Shard Tabletop marketplace.</p>}
            </div>
            <TOS color="titlecolor"/>
            <DistributeCredits open={this.state.showDistribute} onClose={this.showDistribute.bind(this,false)}/>
            <UnlockKeys open={this.state.showUnlockKeys} onClose={this.showUnlockKeys.bind(this, false)}/>
            <SalesResults open={this.state.showSalesResults} onClose={this.showSalesResults.bind(this,false)}/>
            <GlobalEnablePackageDialog open={this.state.showEnablePackageDialog} onClose={this.onCloseDialogs.bind(this)}/>
            <TextBasicEdit show={this.state.changeName} label="New Display Name" text={user.displayName} onChange={this.onNewName.bind(this)} />
            <ConfigurePublisherInfo open={this.state.showPublisherInfo} onClose={this.showPublisherInfo.bind(this,false)} userId={campaign.userId}/>
            <CouponsDialog open={this.state.showCoupons} onClose={this.showCoupons.bind(this,false)}/>
            <ChangePassword open={this.state.showChangePassword} onClose={this.showChangePassword.bind(this,false)}/>
            <SendPublisherEmail open={this.state.showPublisherEmail} onClose={this.setState.bind(this,{showPublisherEmail:false},null, null)}/>
            <ArtPicker defaultType="Wallpaper" open={this.state.showPickWallpaper} onClose={this.pickWallpaper.bind(this)}/>
        </div>;
    }

    onPickWallpaper() {
        this.setState({showPickWallpaper:true})
    }

    pickWallpaper(art) {
        if (art) {
            this.setUserSettings("wallpaper", art.name);
        }
        this.setState({showPickWallpaper:false})
    }

    onChangeVolume(evt, diceVolume) {
        this.setState({diceVolume});
    }

    onCommitChangeVolume(evt, diceVolume) {
        this.setUserSettings("diceVolume", diceVolume);
        this.setState({diceVolume:null});
    }

    setUserSettings(prop, val) {
        const set={};
        if (["none","default"].includes(val)) {
            val=null;
        }
        set[prop]=val;
        campaign.updateUserSettings(set);
        this.setState({update:campaign.newUid()});
    }

    toggleDarkMode() {
        campaign.updateUserSettings({darkMode:!campaign.getUserSettings().darkMode});
    }

    togglePersistance() {
        const newEnable = !getCurrentEnablePersistence();
        setCurrentEnablePersistence(newEnable);
        this.setState({newEnable})
    }

    showDistribute(showDistribute){
        this.setState({showDistribute});
    }

    showChangePassword(showChangePassword) {
        this.setState({showChangePassword});
    }

    showCoupons(showCoupons){
        this.setState({showCoupons});
    }

    showPublisherInfo(showPublisherInfo) {
        this.setState({showPublisherInfo});
    }

    showUnlockKeys(showUnlockKeys) {
        this.setState({showUnlockKeys});
    }
    showSalesResults(showSalesResults) {
        this.setState({showSalesResults});
    }

    clickDisablePackages(){
        this.setState({showEnablePackageDialog:true});
    }
    onCloseDialogs(){
        this.setState({showEnablePackageDialog:false});
    }

    changeName() {
        this.setState({changeName:true});
    }

    resendCode() {
        const res = campaign.sendEmailVerification();
        if (!res) {
            // already verified
            location.reload();
        } else {
            const t=this;
            res.then(function() {
                t.setState({message:"Verification email sent.  Click link in email to verify."})
            }).catch(function(err){
                t.setState({message:"Error sending email verification."});
                console.log("email verification error", err);
            });
            this.setState({message:"Sending email address verification."});
        }
    }

    onNewName(displayName) {
        if (displayName) {
            const t = this;
            const user =campaign.currentUser;

            updateProfile(user, {displayName}).then(function() {
                t.setState({displayName});
                //console.log("set display name")
            }).catch(function(err) {
                console.log("error setting displayName", err);
            });

        }
        this.setState({changeName:false});
    }
}


class AdminOnly extends React.Component {
    constructor(props) {
        super(props);

        this.state= {};
    }

    render() {
        const user =campaign.currentUser;
        const adminLevel = campaign.adminStatus.level;
        const accountant = campaign.accountant;

        return <div className="titletext f2 pa2 titlecolor">
            <div className="f1">
                {user.displayName} 
            </div>
            <div className="mb2 f3">
                {user.email} 
            </div>
            
            <div className="stdcontent">
                                
                {adminLevel?<div className="mb2">
                    <h2>Administrative Actions</h2>
                    <p>
                        <a onClick={this.setAds.bind(this,true)}>Start Page Ads</a>: Setup and Manage Ads.
                    </p>
                    <p>
                        <a onClick={this.setAllPackages.bind(this,true)}>All Packages</a>: View and Assign Packages.
                    </p>
                    <p>
                        <a onClick={this.setShowSendGifts.bind(this,true)}>Send Gifts</a>: Bulk send gifts.
                    </p>
                    <p>
                        <a onClick={this.setShowSendKey.bind(this,true)}>Send Keys</a>: Bulk send keys.
                    </p>
                    <AssignStuff/>
                </div>:null}
                {accountant?<div className="mb2">
                    <p>
                        <a onClick={this.setAccounting.bind(this,true)}>Accounting Reports</a>: View sales and sales tax reports.
                    </p>
                </div>:null}
            </div>
            <TOS color="titlecolor"/>
            <StartAdsDialog open={this.state.setAds} onClose={this.setAds.bind(this,false)}/>
            <AdminPackageDialog open={this.state.showAllPackages} onClose={this.setAllPackages.bind(this,false)}/>
            <Accounting open={this.state.showAccounting} onClose={this.setAccounting.bind(this,false)}/>
            <SendGifts open={this.state.showSendGifts} onClose={this.setShowSendGifts.bind(this,false)}/>
            <SendKeys open={this.state.showSendKey} onClose={this.setShowSendKey.bind(this,false)}/>
        </div>;
    }

    setShowSendGifts(showSendGifts) {
        this.setState({showSendGifts});
    }

    setShowSendKey(showSendKey) {
        this.setState({showSendKey});
    }

    setAds(setAds) {
        this.setState({setAds});
    }

    setAccounting(showAccounting) {
        this.setState({showAccounting});
    }

    setAllPackages(showAllPackages) {
        this.setState({showAllPackages});
    }

    
}

function notBetterShardSub(pkg, products) {
    const allShardSubs = [adventurerProductId,gamemasterProductId,gamemasterProProductId];
    if (!allShardSubs.includes(pkg)) {
        return true;
    }
    if (products[gamemasterProProductId] || products[gamemasterProductId]) {
        return false;
    }
    return true;
}

class NotificationBlock extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnDataChange = this.onDataChange.bind(this);
	    this.state= {};
    }

    componentDidMount() {
        globalDataListener.onChangeCampaignContent(this.handleOnDataChange, "notifications");
        globalDataListener.onChangeUserSettings(this.handleOnDataChange);
    }

    componentWillUnmount() {
        globalDataListener.removeCampaignContentListener(this.handleOnDataChange, "notifications");
        globalDataListener.removeUserSettingsListener(this.handleOnDataChange);
    }

    onDataChange() {
        this.setState({notifications:campaign.getNotifications(), subs:campaign.getUserSettings().ignoreExpiredSubs});
    }

    render() {
        const notifications = campaign.getNotifications();
        const owned = campaign.getOwnedPackages();
        const ignoreExpiredSubs = campaign.getUserSettings().ignoreExpiredSubs||{};
        const expiredSubs = owned.expiredSubs||[];
        const products = owned.products || {};
        const list=[];

        for (let es of expiredSubs) {
            if (notBetterShardSub(es.pkg, products) && !areSameDeep(ignoreExpiredSubs[es.pkg],es.date)) {
                list.push(<div key={es.pkg} className="flex f3">
                    <div className="flex-auto pv1"><span className="red">Subscription Expired!</span> <a href={"/marketplace#product?id="+es.pkg}>Renew your {es.name} subscription now</a></div>
                    <div className="pa1 fas fa-times hoverhighlight" onClick={this.ignoreExpiredSub.bind(this,es)}/>
                </div>);
            }
        }

        for (let i in notifications) {
            const n = notifications[i];
            switch (n.type) {
                case "addpackage":
                    const pkg = campaign.getPackageInfo(n.pkg)
                    if (pkg) {
                        list.push(<div key={n.name} className="flex hoverhighlight f3">
                            <div className="flex-auto pv1" onClick={this.showPackage.bind(this,pkg)}>New Package: <a>{pkg.name}</a></div>
                            <div className="pa1 fas fa-times" onClick={this.deleteNotification.bind(this,n.name)}/>
                        </div>);
                    }
                    break;
                default:
                    console.log("unknown notification", n.type);
                    break;
            }
        }

        if (!list.length) {
            return null;
        }
        return <div className="mt2 flex">
            <div className="flex-auto"/>
            <div className="ba br2 titleborder defaultbackground pa1 titletext titlecolor mh2">
                <div className="tc f2">Notifications {list.length>1?<a className="fr f7 ph1" onClick={this.deleteAllNotifications.bind(this)}>clear all</a>:null}</div>
                {list}
            </div>
            <div className="flex-auto"/>
            <PackageDialog open={this.state.showPkg} pkg={this.state.showPkg} onClose={this.showPackage.bind(this,null)} showBooks/>
        </div>;
    }

    showPackage(showPkg) {
        this.setState({showPkg});
    }

    deleteAllNotifications() {
        const notifications = campaign.getNotifications();
        for (let i in notifications) {
            campaign.deleteCampaignContent("notifications", notifications[i].name);
        }
    }

    deleteNotification(name) {
        campaign.deleteCampaignContent("notifications", name);
    }

    ignoreExpiredSub(es) {
        const ignoreExpiredSubs = Object.assign({},campaign.getUserSettings().ignoreExpiredSubs||{});
        ignoreExpiredSubs[es.pkg]=es.date;
        campaign.updateUserSettings({ignoreExpiredSubs});
    }
}


class HeaderMenu extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const signedIn = campaign.currentUser;
        const adminLevel = campaign.adminStatus.level;
        const accountant = campaign.accountant;
        if (!signedIn && !this.props.onDoAuth)
            return null;

        return <HoverMenu placement="bottom" buttonMenu={<span className="pa1 fas fa-bars"/>} closeOnClick>
            <Paper>
                {this.props.includeMarketplace?<MenuItem  onClick={this.gotoLink.bind(this, "/marketplace")}>
                    Marketplace
                </MenuItem>:null}
                <MenuItem  onClick={this.gotoLink.bind(this, addCampaignToPath("/#home"))}>
                    Play
                </MenuItem>
                {signedIn?<MenuItem  onClick={this.gotoLink.bind(this, addCampaignToPath("/#mycharacters"))}>
                    Characters
                </MenuItem>:null}
                {signedIn?<MenuItem  onClick={this.gotoLink.bind(this, "/#campaigns")}>
                    Campaigns
                </MenuItem>:null}
                {signedIn?<MenuItem  onClick={this.gotoLink.bind(this, addCampaignToPath("/#book"))}>
                    Library
                </MenuItem>:null}
                {signedIn?<MenuItem  onClick={this.gotoLink.bind(this, addCampaignToPath("/#reference"))}>
                    Reference
                </MenuItem>:null}
                {signedIn?<MenuItem  onClick={this.gotoLink.bind(this, addCampaignToPath("/#mycreations"))}>
                    My Creations
                </MenuItem>:null}
                {signedIn?<MenuItem  onClick={this.gotoLink.bind(this, "/#settings")}>
                    Account
                </MenuItem>:null}
                {signedIn?adminLevel||accountant?<MenuItem  onClick={this.gotoLink.bind(this, "/#admin")}>
                    Admin
                </MenuItem>:null:null}
                {signedIn?<MenuItem  onClick={this.signOut.bind(this)}>
                    Sign Out
                </MenuItem>:<MenuItem  onClick={this.signIn.bind(this)}>
                    Sign In
                </MenuItem>}
                <Divider/>
                <MenuItem  onClick={this.gotoLink.bind(this, "https://shardtabletop.com")}>
                    ShardTabletop.com
                </MenuItem>
                <MenuItem  onClick={this.gotoLink.bind(this, "https://shardtabletop.com/learning")}>
                    Learning
                </MenuItem>
            </Paper>
        </HoverMenu>;
    }
    
    gotoLink(href) {
        if (this.props.refVal) {
            href = href+(href.includes("?")?"&ref=":"?ref=")+encodeURIComponent(this.props.refVal);
        }
        window.location.href = href;
    }

    signOut() {
        campaign.unsubscribeAll();
        getAuth(firebase).signOut();
    }

    signIn() {
        this.props.onDoAuth();
    }
}


function TOS(props) {
    return <div className={"mv3 "+(props.color||"white")}>
        <div className="tc titletext f2">
            Copyright (c) 2020-2025 Shard Tabletop Inc.
        </div>
        <div className="mv1 tc titletext f4">
            <a href="https://shardtabletop.com/terms">Terms of Service</a> and <a href="https://shardtabletop.com/privacy">Privacy Statement</a>
        </div>
    </div>;
}

function triggerEvent(eventSync, event, data) {
    eventSync.emit(event, data);
}

function navTo(base, name) {
    window.location.href = base+(name?encodeURIComponent(name):"");
}


export {
    HomePage,
    AccountSettings,
    AdminOnly,
    HeaderMenu,
    CampaignsHeader,
    CampaignsList,
    GamePlayReferenceList,
}